import { useState } from 'react';
import { IconArrowRightSolid } from '@/app/common/icons/libraryIcons';
import { useTranslation } from '@/app/components/translations/Translation';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import dynamic from 'next/dynamic';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import {
  BasicBannerContainer,
  BasicBannerHeadingContainer,
  BasicBannerImageContainer,
  BasicBannerTextContainer,
} from './styled';
import InfoIcon from '../../../common/Icons/InfoIcon';

type SustainabilityBannerProps = {
  isPill?: boolean;
};

const SustainabilityModal = dynamic(() => import('../../Modal/Modals/SustainabilityModal'));

const SustainabilityBanner = ({ isPill = false }: SustainabilityBannerProps) => {
  const { localization } = usePageWrapperData();
  const { isMobile } = useCommonClient();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const handleOnClick = () => {
    setShowModal(true);
  };

  return isPill ? (
    <BasicBannerContainer isPill={true} isMobile={isMobile} as="div">
      {t('vacation.oss.emissions.modal.title')} <InfoIcon />
    </BasicBannerContainer>
  ) : (
    <>
      <BasicBannerContainer onClick={handleOnClick} isPill={false} isMobile={isMobile} as="button">
        <BasicBannerImageContainer>
          {/* The multicolour planet illustration, as on the hotel page's emissions section. */}
          <img src={`${localization.imageBasePath}icons/planet-heart.svg`} alt="" />
        </BasicBannerImageContainer>
        <BasicBannerTextContainer>
          <BasicBannerHeadingContainer>{t('vacation.oss.emissions.banner.title')}</BasicBannerHeadingContainer>
        </BasicBannerTextContainer>
        <IconArrowRightSolid />
      </BasicBannerContainer>
      <SustainabilityModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default SustainabilityBanner;
